import { type Editor } from '@tiptap/core';

export function getSelectionElement(editor: Editor) {
  try {
    const { from } = editor.state.selection;
    const domAtPos = editor.view.domAtPos(from);

    // domAtPos returns { node, offset }
    // node can be a text node, so we need to get the parent element
    const node = domAtPos.node;

    if (node instanceof HTMLElement) {
      return node;
    }

    // If it's a text node, return the parent element
    if (node.parentElement) {
      return node.parentElement;
    }

    return null;
  } catch (_error) {
    return null;
  }
}
